// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c1da6b3e","239":"03e4c80b","455":"f52743ed","574":"51637033"}[chunkId] + ".chunk.js";
};